import React from 'react';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import NotFound from '@components/organisms/NotFound';

const NotFoundPage: React.FC = () => {
  const isLoggedIn = useAppSelector((state: RootState) => state.user.isLoggedIn);
  return <NotFound isAuthenticated={Boolean(isLoggedIn)} />;
};

export default NotFoundPage;
